"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scanQRCode = void 0;
/**
 * 一维码、二维码扫码
 * @returns
 */
function scanQRCode() {
    return new Promise(function (resolve, reject) {
        var barcode = null;
        var barcodeWebview = null;
        // 扫码成功回调
        function onmarked(type, result) {
            barcode && barcode.close();
            barcodeWebview && barcodeWebview.close();
            resolve(result);
        }
        // 扫码失败回调
        function onerror(error) {
            barcode && barcode.close();
            barcodeWebview && barcodeWebview.close();
            reject(error);
        }
        // 创建Barcode扫码控件
        function createBarcode() {
            if (!barcode) {
                barcode = window.plus.barcode.create('barcode', [window.plus.barcode.QR, window.plus.barcode.EAN13, window.plus.barcode.EAN8], {
                    top: '50px',
                    left: '0px',
                    width: '100%',
                    height: '100%',
                    position: 'static',
                });
                barcode.onmarked = onmarked;
                barcode.onerror = onerror;
                barcodeWebview = window.plus.webview.create('../router.html', 'barcode', {}, { routerId: 'barcode' });
                barcodeWebview && barcodeWebview.append(barcode);
                barcodeWebview && barcodeWebview.show();
            }
            barcode.start();
        }
        try {
            createBarcode();
        }
        catch (error) {
            console.error("".concat(error.name, ": ").concat(error.message));
            reject(error);
        }
    });
}
exports.scanQRCode = scanQRCode;
//# sourceMappingURL=barcode.js.map